import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'

export function useUpdateOrganization(organizationId: string | null) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (name: string) => {
      if (!organizationId) throw new Error('No organization ID')

      const { data, error } = await supabase
        .from('organizations')
        .update({ name, updated_at: new Date().toISOString() })
        .eq('id', organizationId)
        .select()
        .single()

      if (error) throw error
      return data
    },
    onSuccess: (_data, _variables) => {
      if (organizationId) {
        queryClient.invalidateQueries({ queryKey: ['organization', organizationId] })
      }
    },
  })
}
